import { render, staticRenderFns } from "./IntentDescriptionEditor.vue?vue&type=template&id=3e002aa4&"
import script from "./IntentDescriptionEditor.vue?vue&type=script&lang=js&"
export * from "./IntentDescriptionEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports